import { ErrorMessageDetail } from '../../modules/manage-types-upload-memo/shared/manage-types-upload-memo.models';
import * as moment from 'moment/moment';

export enum Language {
  th = 'th',
  en = 'en',
}

export function toTitleCase(str: string): string {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1);
  });
}

export function buildErrorHTMLMessage(
  error: ErrorMessageDetail,
  wrap?: boolean,
): string {
  if (Array.isArray(error)) {
    const list = error
      .map((errorItem) => {
        return typeof errorItem === 'string'
          ? `<li>${errorItem}</li>`
          : buildErrorHTMLMessage(errorItem);
      })
      .join('');
    return `<ul class="mb-0 pl-3">${list}</ul>`;
  }

  if (typeof error === 'string') {
    return wrap
      ? `<ul class="mb-0 pl-3"><li>${error}</li></ul>`
      : error;
  }

  return Object.entries(error)
    .map(([key, value]) => {
      return `
        <ul class="mb-0 pl-3">
          <li>${toTitleCase(key)}
            ${buildErrorHTMLMessage(value, true)}
          </li>
        </ul>
      `;
    })
    .join('');
}

export function buildFullName(
  firstname: string,
  lastname: string,
): string {
  if (firstname && lastname) {
    return `${firstname} ${lastname}`;
  } else {
    return firstname || lastname;
  }
}

export function generateUUID() {
  // Public Domain/MIT
  let d = new Date().getTime(); // Timestamp
  let d2 =
    (performance && performance.now && performance.now() * 1000) || 0; // Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    (c) => {
      let r = Math.random() * 16; // random number between 0 and 16
      if (d > 0) {
        // Use timestamp until depleted
        // tslint:disable-next-line:no-bitwise
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        // Use microseconds since page-load if supported
        // tslint:disable-next-line:no-bitwise
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      // tslint:disable-next-line:no-bitwise
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    },
  );
}

export function diffDurationDateTime(
  startDate: string,
  endDate: string,
): { [key: string]: number } {
  let start = moment(startDate);
  let end = moment(endDate);

  if (start > end) {
    const tempDate = start;
    start = end;
    end = tempDate;
  }

  // include end day (add 1 day)
  end.add(1, 'day');

  const years = end.diff(start, 'years');
  start.add(years, 'years');
  const months = end.diff(start, 'months');

  return {
    years: years,
    months: months,
  };
}

export function replaceUnderscore(
  text: string,
  withChar = '-',
): string {
  return text.split(/_/g).join(withChar);
}

export function buildNumberList(maxNumber = 31): number[] {
  return Array.from({ length: maxNumber }, (_, index) => index + 1);
}

export function buildArrayLength(length, obj) {
  return Array(length).fill({ ...obj });
}

export function toDecimal(value: any, digit = 2): any {
  if (value === null || value === undefined) {
    return value;
  }
  if (
    typeof value === 'string' &&
    (value.includes('%') || isNaN(parseFloat(value)))
  ) {
    return value;
  }
  if (typeof value === 'number' || !isNaN(parseFloat(value))) {
    const numValue =
      typeof value === 'number' ? value : parseFloat(value);
    return parseFloat(numValue.toFixed(digit));
  }
  return value;
}
